module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/facebook-a6b128f68acf2d76b41a2220fa035250.png";